module.exports = __webpack_public_path__ + "static/media/githubBackground.0b819d63.svg";